(function() {
    'use strict';

    angular
        .module('app.smartExportGuarantee', [
            'app.core',
            'utils'
        ]);
})();